<template>
  <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.672396 15.5L18.1641 8L0.672396 0.5L0.664062 6.33333L13.1641 8L0.664062 9.66667L0.672396 15.5Z" fill="currentColor"/>
  </svg>
</template>
